import React, { useState } from "react";
import { connect,  useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Col } from "@themesberg/react-bootstrap";
import TextField from "@material-ui/core/TextField";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loader, Button } from "rsuite";
import { Card } from "react-bootstrap";

import {
  getProfile,
  setUserRole,
  setSingleWallet,
  setUserPayString,
  getPermissions,
} from "../../redux/actions/auth";
import { getBusinessDetails } from "../../redux/actions/businessApi";
import { Routes } from "../../routes";
import * as API from "../../ApiUrl";
import { MERCHANT_PROFILE } from "../../ApiUrl";
import * as actionTypes from "../../redux/actionTypes";
import mail from "../../assets/img/icons/mail.svg";
import stblogo from "../../assets/img/stbLogo.png";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FormControl from "@mui/material/FormControl";
import ReCAPTCHA from "react-google-recaptcha";
import { textFieldLabelProps } from "../../utils/common";
import { FormHelperText } from "@material-ui/core";
import { updateXRefreshToken } from "../../redux/actions/profileActions";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string("Enter your password").required("Password is required"),
});


const Signin = ({
  setUserRole,
  setSingleWallet,
  changepage,
  setUserPayString,
  getBusinessDetails,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = React.useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);

  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const onSubmit = async (values) => {
    let isKycApproved = false;
    let kycStatus = "not_done";
    let kybStatus = "not_done";

    setLoading(true);

    try {
      const response = await axios.post(API.LOGIN_API, {
        ...values,
        token: captchaToken,
      });

      const { token } = await response.data;

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.access}`,
        },
      };

      // Get user profile and store in redux
      try {
        const response = await axios.get(`${MERCHANT_PROFILE}profile/`, config);
        const {
          data: {
            data: profileData,
            data: {
              merchant: { kyb_status, kyc_status },
            },
          },
        } = response;
        kybStatus = kyb_status;
        kycStatus = kyc_status;
        dispatch({ type: actionTypes.SET_PROFILE, payload: profileData });
      } catch (err) {
        console.log("csdcsc2ec423c23c", err);
        toast.error(err?.response?.data?.message || "Something went wrong");
      }

      // Get user stores and store in redux
      try {
        const response = await axios.get(
          `${API.STORE_LIST}?limit=1000`,
          config
        );

        if (response?.data?.results) {
          dispatch({
            type: actionTypes.SET_STORE_LIST,
            payload: response?.data?.results,
          });
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }

      dispatch(getPermissions());
      dispatch(updateXRefreshToken());

      localStorage.setItem("user-info", JSON.stringify(response?.data));
      localStorage.setItem("token", token?.access);
      localStorage.setItem("refresh", token?.refresh);
      localStorage.setItem("user-role", response?.data?.user_role);
      await setUserRole(response?.data?.user_role);
      await setSingleWallet();
      await setUserPayString();
      await getBusinessDetails();

      setLoading(false);
      if (kybStatus === "not_done" || kycStatus === "not_done") {
        history.replace("/administration/updatebusinessdetails");
      } else {
        history.replace("/");
      }
    } catch (err) {
      setLoading(false);
      toast.error(
        err?.response?.data?.message ||
          "We are experiencing some technical difficulties, please try again in sometime or email support at help@spendthebits.com"
      );
    }
  };

  const onCaptchaClick = async (value) => {
    setCaptchaToken(value);
    setIsCaptchaValid(true);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validateOnBlur: true,
    onSubmit,
    validationSchema: validationSchema,
  });

  return (
    <main className="signInPage signupbg">
      <section className="signInheader">
        <img src={stblogo} alt="SpendTheBits logo" />
      </section>
      <section className="signInContent">
        <div className="signInBox">
          <div className="signInBoxHeader">
            <p className="dialog-title fw-bolder">Sign in</p>
            <p>Welcome to SpendTheBits Cash Merchant Portal</p>
          </div>
          <div>
            <Col xl={12} xs={12}>
              <TextField
                className="w-100 mb-4 mt-2"
                variant="outlined"
                name="email"
                id="email"
                label="Email"
                type="email"
                InputLabelProps={textFieldLabelProps}
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Col>
            <Col xl={12} xs={12}>
              <FormControl
                sx={{ mt: 1 }}
                variant="outlined"
                className="w-100 pb-0 mb-0"
              >
                <InputLabel
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  htmlFor="password"
                >
                  Password
                </InputLabel>
                <OutlinedInput
                  className="w-100"
                  id="password"
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  InputLabelProps={textFieldLabelProps}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {formik.touched.password && formik.errors.password ? (
                  <FormHelperText error>
                    {formik.errors.password}
                  </FormHelperText>
                ) : null}
              </FormControl>
            </Col>
          </div>
          <div
            className="text-primary mb-2 mt-1 fw-bolder"
            style={{ textAlign: "right" }}
          >
            <Link to={Routes.ForgotPassword.path}>Forgot password?</Link>
          </div>
          <div className="submitBtnContainer">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
              onChange={onCaptchaClick}
            />
            <Button
              disabled={!formik.isValid || !isCaptchaValid}
              className={`btn action-button primary_color mt-0 text-white grow-1 w-100 mt-4 ${
                !formik.isValid || !isCaptchaValid ? "disabled" : null
              }`}
              loading={loading}
              onClick={() => {
                setIsButtonLoading(true);
                setTimeout(() => {
                  setIsButtonLoading(false);
                }, 2000);
                formik.handleSubmit();
              }}
            >
              Sign In
            </Button>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            <span className="fw-normal" style={{fontSize: '16px'}}>
              Dont have an account?
              <Card.Link
                onClick={() => history.push("/signup")}
                className="fw-bold text-primary"
              >
                {` Sign up `}
              </Card.Link>
            </span>
          </div>
        </div>
      </section>
      <section className="signInFooter">
        <a
          className="social twitter"
          href="https://twitter.com/Spend_The_Bits"
          target="_blank"
          rel="noopener noreferrer"
        >
          @Spend_The_Bits_Cash_Merchant_Portal
        </a>
        <a
          className="social mail"
          href="mailto:help@spendthebits.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={mail} alt="mail" />
          help@spendthebits.com
        </a>
      </section>
    </main>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    // explicitly forwarding arguments
    getprofile: () => dispatch(getProfile()),
    setUserRole: (val) => dispatch(setUserRole(val)),
    setSingleWallet: () => dispatch(setSingleWallet()),
    setUserPayString: () => dispatch(setUserPayString()),
    getBusinessDetails: () => dispatch(getBusinessDetails()),
  };
};
export default connect(null, mapDispatchToProps)(Signin);
